export const CONTRACT_AGREEMENT = '/:degree/contracts'
export const CONTRACT_PAGE = '/potential-talaba'
